import React, {
    useRef, useState,
    // useEffect
} from 'react';
import Modal from 'react-bootstrap/Modal';

import axios from 'axios';
import {
    // formatMoneda, formatoMonto, validaMonto, 
    validaSoloNumero
} from '../../util/varios';
import {
    Mensaje,
    // MensajeSiNo 
} from '../mensajes2';
import moment from 'moment';
import { Dimmer } from '../spinner';

import CatalogoOrdenPago3 from '../../catalogos/catalogoOrdenPago3';

import CatalogoOrdenPagoUbi from '../../catalogos/catalogoOrdenPagoUbi';

export const AgregarOrdenPagoDevolver = (props) => {
    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    // const idusuario = JSON.parse(localStorage.getItem('idusuario'));
    // const fechaSistema = JSON.parse(localStorage.getItem('fechasistema'));

    const [activate, setActivate] = useState(false);
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [mostrar4, setMostrar4] = useState(false);
    // const [val, setVal] = useState(0);
    const [val2, setVal2] = useState(0);
    const [activo, setActivo] = useState(true);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    // const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtId = useRef();
    const txtIdCom = useRef();
    const txtRazon = useRef();
    const txtIdprov = useRef();
    const txtFecha = useRef();
    const txtUbi = useRef();
    const txtDescriclas = useRef();
    // const txtMonto = useRef();
    // const txtMontoiv = useRef();
    // const txtFechacrea = useRef();
    const txtTipo = useRef();
    const txtMotivo = useRef();
    const txtIdordenpago = useRef();


    const cancelar = () => {
        blanquear();
        props.onHideCancela();
    }

    const blanquear = () => {
        setActivate(false);
        setActivo(true);
    };

    const cerrarModal = () => {
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onHideRenderizar();
        props.onHideCancelar();
        blanquear();
    }

    const catalogoClass = (e) => {
        e.preventDefault();
        setMostrar4(true);
    };

    const handleInputNumChange = (event) => {
        event.preventDefault();
        validaSoloNumero(event);
        if (event.which === 13 || typeof (event.which) === 'undefined') {
        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;
    };
    const handleAceptaOrdenesPagos = (value) => {
        setMostrar4(false);
        var valida = 1;
        if (props.idval.length > 0) {
            for (let i = 0; i < props.idval.length; i++) {
                if (value.numordenpago !== props.idval[i].numordenpago) {
                    txtId.current.value = value.numordenpago;
                    txtDescriclas.current.value = value.concepto.trim();
                    txtIdCom.current.value = value.idcompromiso;
                    txtRazon.current.value = value.proveedor.trim();
                    txtIdprov.current.value = value.idproveedor;
                    txtFecha.current.value = moment.utc(value.fecha).format('DD-MM-YYYY');
                    txtUbi.current.value = value.ubicacion;
                    txtIdordenpago.current.value = value.idordenpago;
                    txtTipo.current.value = value.tipo;
                    setActivo(false);
                } else {
                    valida = 7;
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ Esta Orden ya fue Seleccionada !', icono: 'informacion' });
                }
                if (valida === 7) {
                    txtId.current.value = '';
                    txtDescriclas.current.value = '';
                    txtIdCom.current.value = '';
                    txtRazon.current.value = '';
                    txtIdprov.current.value = '';
                    txtFecha.current.value = '';
                    txtUbi.current.value = '';
                    txtIdordenpago.current.value = '';
                    txtTipo.current.value = '';
                    break;
                }
            }
        } else {
            txtId.current.value = value.numordenpago;
            txtDescriclas.current.value = value.concepto.trim();
            txtIdCom.current.value = value.idcompromiso;
            txtRazon.current.value = value.proveedor.trim();
            txtIdprov.current.value = value.idproveedor;
            txtFecha.current.value = moment.utc(value.fecha).format('DD-MM-YYYY');
            txtUbi.current.value = value.ubicacion;
            txtIdordenpago.current.value = value.idordenpago;
            txtTipo.current.value = value.tipo;
            setActivo(false);
        }

    }
    const seleccionarOrdenesPagos = (id) => {
        let endpoint = `${op.conexion}/api/administracion/registrosordenpagoid?id=${id}&idefiscal=${idefiscal}`;
        setActivate(true);
        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {
            if (response.status === 200) {
                if (response.data.numordenpago > 0) {
                    setActivate(false);
                    //txtId.current.value = response.data.idordenpago;
                    txtDescriclas.current.value = response.data.concepto.trim();
                    txtIdCom.current.value = response.data.idcompromiso;
                    txtRazon.current.value = response.data.razonsocial.trim();
                    txtIdprov.current.value = response.data.idproveedor;
                    txtFecha.current.value = moment.utc(response.data.fecha).format('DD-MM-YYYY');
                    txtUbi.current.value = response.data.ubicacion;
                    txtIdordenpago.current.value = response.data.idordenpago;
                    txtTipo.current.value = response.data.tipo;
                    txtMotivo.current.focus();
                    setActivo(false);
                } else {
                    setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'La Orden de Pago no existe.', icono: 'informacion' });
                    txtId.current.value = '';
                    txtDescriclas.current.value = '';
                    txtIdCom.current.value = '';
                    txtRazon.current.value = '';
                    txtIdprov.current.value = '';
                    txtFecha.current.value = '';
                    txtUbi.current.value = '';
                    txtIdordenpago.current.value = '';
                    txtTipo.current.value = '';
                    setActivo(true);
                }
            }
        }).catch(function (error) {
            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
        }).finally(function () {
            setActivate(false);
        });

    }

    const handleSolicitudes = (event) => {
        event.preventDefault();
        txtDescriclas.current.value = '';
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            if (event.target.value !== '') {
                seleccionarOrdenesPagos(event.target.value);
            }
        }
    };

    const onChangeValidar = (e) => {
        e.preventDefault();
        var sigue = true;
        if (txtMotivo.current.value.trim() === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: '¡ El Motivo no debe ir Vacio !', icono: 'informacion' });
            sigue = false;
            txtMotivo.current.focus();
        }

        else if (sigue) {
            seleccionarSolicitudesPagos();
        }

    };

    const seleccionarSolicitudesPagos = () => {
        blanquear();
        var datos = [];
        datos.push({
            numordenpago: txtId.current.value,
            idcompromiso: txtIdCom.current.value,
            razonsocial: txtRazon.current.value.trim(),
            concepto: txtDescriclas.current.value.trim(),
            idproveedor: txtIdprov.current.value,
            fecha: txtFecha.current.value,
            ubicacion: txtUbi.current.value.trim(),
            idordenpago: txtIdordenpago.current.value,
            tipo: txtTipo.current.value,
            motivo: txtMotivo.current.value.trim()
        });
        props.onDatos(datos);
        props.onHideCancela();
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                if (props.operacion === 1) {
                    setVal2(1);
                } else {
                    txtId.current.value = '';
                    txtDescriclas.current.value = '';
                    txtIdCom.current.value = '';
                    txtRazon.current.value = '';
                    txtIdprov.current.value = '';
                    txtFecha.current.value = '';
                    txtUbi.current.value = '';
                    txtIdordenpago.current.value = '';;
                    txtTipo.current.value = '';
                    txtMotivo.current.value = '';
                    <input type='hidden' ref={txtRazon} />
                }
            }}>
            <Modal.Header className='header-azulGradiant'>
                <h3>
                    Documento a Devolver
                </h3>
                <a type='button' onClick={cancelar}>
                    salir<i className="fa fa-times"></i>
                </a>
            </Modal.Header>
            <Modal.Body>
                <CatalogoOrdenPagoUbi
                    show={mostrar4}
                    onHideCancela={() => { setMostrar4(false) }}
                    onHideAceptaCatalogo={handleAceptaOrdenesPagos}
                    ubicacion={44}
                    status={0}
                />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div style={{ height: '300px' }} className='overflow-auto'>
                    <input type='hidden' ref={txtIdCom} />
                    <input type='hidden' ref={txtIdordenpago} />
                    <input type='hidden' ref={txtRazon} />
                    <input type='hidden' ref={txtIdprov} />
                    <input type='hidden' ref={txtFecha} />
                    <input type='hidden' ref={txtUbi} />
                    <input type='hidden' ref={txtTipo} />
                    <div className='col-md-12 py-2'></div>
                    <fieldset className="row border-azul rounded mx-auto">
                        <legend className="float-none m-0 w-auto">Incluir Documento</legend>
                        <div className='container row m-0 d-flex justify-content-center col-12 mx-auto px-0'>
                            <div className='mb-2'></div>
                            <div className='col-sm-3 mb-2 px-1'>
                                <div className="input-group input-group-sm m-0 w-100">
                                    <label className="input-group-text">Código:</label>
                                    <input type="text" name='codigo' ref={txtId} onKeyUp={handleSolicitudes} onBlur={handleInputNumChange} className="form-control bg-light" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputLogin" />
                                    <button disabled={operacion === 4 || operacion === 2 ? true : deshabilitado} onClick={catalogoClass} className="btn btn-sm  btn-light border shadow-none" ><i className="fa fa-search"></i> </button>
                                </div>
                            </div>

                            <div className='col-sm-9 px-1'>
                                <div className='col-sm-12 mb-2 px-0'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" >Concepto:</label>
                                        <textarea type="text" className="form-control text-uppercase bg-light" style={{ height: '60px' }} disabled={true} ref={txtDescriclas} placeholder="Descripción del Documento" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputDireccion" />
                                    </div>
                                </div>
                            </div>

                            <div className='col-sm-12 px-1'>
                                <div className='col-sm-12 mb-2 px-0'>
                                    <div className="input-group input-group-sm m-0 w-100">
                                        <label className="input-group-text" >Motivo:</label>
                                        <textarea type="text" className="form-control text-uppercase" style={{ height: '60px' }} ref={txtMotivo} placeholder="Describa el Motivo" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputDireccion" />
                                    </div>
                                </div>
                            </div>

                        </div>

                    </fieldset>

                </div>
            </Modal.Body>
            <Modal.Footer className='footer-azulGradiant'>
                <button type="button"
                    ref={btnAcepta}
                    onClick={onChangeValidar}
                    disabled={activo}
                    className="btn btn-sm rounded btnPrimary-azulGradiant">
                    <i className="far fa-check-circle"></i> Aceptar
                </button>
                <button type="button"
                    ref={btnCancela}
                    onClick={cancelar}
                    className=" btn btn-sm rounded btnSecondary-azulGradiant">
                    <i className="fas fa-window-close"></i> Cancelar
                </button>
            </Modal.Footer>
            <Mensaje mensaje={mensaje}
                onHide={() => {
                    mensaje.titulo === 'Exito.' ?
                        cerrarModal() :
                        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                }
                } />

        </Modal>

    );
}